import {
    apiRequest,
    masterCategoriessos,
    acsosiokulturalDetail,
    acsosiokulturalLevel,
    acsosiokulturalUpdate
} from "../../../../../services/adapters/kepegawaian/Accompetence"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", acsosiokulturalDetail, {
            params: query
        }, true)
    }

    fetchLevel = async (query) => {
        return await apiRequest("get", acsosiokulturalLevel, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", acsosiokulturalUpdate, {
            body: query
        }, true)
    }

    fetchCategories = async (query) => {
        return await apiRequest("get", masterCategoriessos, {
            params: query
        }, true)
    }
}

export default UpdateRepository